import { toast } from "react-toastify";
import { _single, _UBLInvoice } from "../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { useUBLInvoiceActions } from "../../../../contract/etapa-contrato/contrac/ublinvoice/hooks/useUBLInvoiceActions";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import { _SalesOrder } from "../../../../../core/services/dataBean/EntityCatalogVdos";
import useModal, { MODAL_LG } from "../../../../theme/Component/hooks/useModal";
import { Modal } from "../../../../theme/Component/Modal";
import { SelectProject } from "../../../../erp/cellEditor/BudgetAccountantOperation/SelectProject";
import { SelectBusinessCore } from "../../../../erp/cellEditor/BusinessCore/SelectBusinessCore";
import { useEffect } from "react";

interface ComponentSalesOrderProps {
    IDSalesOrder: number;
    SalesOrderDate: any;
}


export const SalesOrderUBLInvoice = ({ IDSalesOrder, SalesOrderDate }: ComponentSalesOrderProps) => {

    const { instance, bean, setBean, lista, setLista, isMissing, isRequired } = useDataBean(_UBLInvoice);

    const modal = useModal("", MODAL_LG);
    const { listButtons: ublInvoiceActionButtons, actionModals: ublInvoiceActionModals, head: ublInvoiceHead } = useUBLInvoiceActions({
        invoice: bean,
        actionKeys:
            [
                // "edit",
                "items",
                "withholdingTaxes",
                // "accountingDocuments",
                // "invoiceDocument",
                // "payments",
                // "events",
                // "crossPrepaid",
                // "applyPrepaid",
                // "contingency",
                // "setAsSale",
                // "proforma",
                // "description",
                // "accountantConcept",
                // "paymentTerms",
                // "currency",
                // "createAccounting",
                // "fireElectronicDocument",
                // "adjustmentNotes",
                // "radianEvents",
                // "duplicate",
                // "xml",
                // "notifyEmail",
                // "notifySiif",
                // "fixedAssetEntry",
                // "invoiceAttachment",
                "nullify",
                // "paymentType",
                // "accountingDocument",
                // "fixedAssetDocument",
                // "obligationDocument",
                // "relatedDocument",
                // "discrepancyResponse",
            ]
        ,
        canView: true,
        canDelete: true,
        onChange: () => { getLista() },
        useSupplierPaymentType: true,
        isCash: false,
    });

    useEffect(() => {
        getLista();
    }, [IDSalesOrder])

    const getLista = () => {
        instance.getUblInvoiceCatalogBySalesOrder(IDSalesOrder, SalesOrderDate, null).then(
            (resp) => {
                setLista(resp)
            }
        ).catch(err => { toast.error(err) })
    }

    const create = () => {
        setBean({});
        modal.open("Crear Factura");
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create },
    ]

    const formUBL = () => {
        return (
            <div className="row">
                <div className="col-md-6">
                    <label className={`${isMissing('IDProject') ? 'has-error' : ''}`}>Proyecto {isRequired('IDProject') ? <span className="text-danger">*</span> : ''}</label>
                    <SelectProject
                        label=" "
                        idSelector={bean.IDProject}
                        onChange={(value) => {
                            if (!value) {
                                setBean({
                                    ...bean,
                                    IDProject: null,
                                    IDBusinessCore: null
                                });
                                return;
                            }

                            const { IDProject, IDBusinessCore } = value;
                            setBean({
                                ...bean,
                                IDProject: IDProject ?? null,
                                IDBusinessCore: IDBusinessCore ?? null
                            });
                        }}
                        returnType="Object"
                    />

                </div>

                <div className="col-md-6">
                    <label className={`${isMissing('IDBusinessCore') ? 'has-error' : ''}`}>Línea de Negocio {isRequired('IDBusinessCore') ? <span className="text-danger">*</span> : ''}</label>
                    <SelectBusinessCore returnType="ID" idSelector={bean.IDBusinessCore} label=" " onChange={(e) => { setBean({ ...bean, "IDBusinessCore": e }) }} />
                </div>

                <div className="col-md-12">
                    <label>Observaciones</label>
                    <textarea className="form-control" value={bean.Observations} onChange={(e) => { setBean({ ...bean, "Observations": e.target.value }) }}></textarea>
                </div>
            </div >
        )
    }

    const addUbl = () => {
        instance.createSalesOrderUBLInvoice(IDSalesOrder, SalesOrderDate, _single.getAccountID(), bean.Observations, bean.IDBusinessCore, bean.IDProject).then(
            (resp) => {
                console.log(resp);
                getLista();
                modal.close();
            }
        ).catch(err => { toast.error(err) })
    }

    return (
        <div className="row">
            <div className="col-md-12">
                <BasicTable body={lista} head={ublInvoiceHead} rowSet={setBean} iconButtons={iconButtonsItem} listButtons={ublInvoiceActionButtons} />

                <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { addUbl() }} onSubmitLabel={bean.IDUBLInvoice ? "Editar Factura de Proveedor" : null}>
                    {formUBL()}
                </Modal>

                {ublInvoiceActionModals}


            </div>
        </div>
    )
}










